/*!
 * Module exports.
 */

'use strict';

exports.Binary = require('./binary');
exports.Collection = function() {
  throw new Error('Cannot create a collection from browser library');
};
exports.Decimal128 = require('./decimal128');
exports.ObjectId = require('./objectid');
exports.ReadPreference = require('./ReadPreference');



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/drivers/browser/index.js
// module id = 331
// module chunks = 0